import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C1490.19336,0 1920,429.80664 1920,960 C1920,1490.19336 1490.19336,1920 960,1920 C429.80664,1920 0,1490.19336 0,960 C0,429.80664 429.80664,0 960,0 Z M960,101.052632 C485.616468,101.052632 101.052632,485.616468 101.052632,960 C101.052632,1434.38353 485.616468,1818.94737 960,1818.94737 C1434.38353,1818.94737 1818.94737,1434.38353 1818.94737,960 C1818.94737,485.616468 1434.38353,101.052632 960,101.052632 Z M950.679927,1322.54386 C870.655911,1322.54386 805.551855,1387.64792 805.551855,1467.67193 C805.551855,1547.69595 870.655911,1612.8 950.679927,1612.8 C1030.70394,1612.8 1095.808,1547.69595 1095.808,1467.67193 C1095.808,1387.64792 1030.70394,1322.54386 950.679927,1322.54386 Z M1143.46512,353.684211 L757.894737,353.684211 L851.795993,1205.0114 L1049.56386,1205.0114 L1143.46512,353.684211 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconWarningLine = /*#__PURE__*/function (_Component) {
  _inherits(IconWarningLine, _Component);

  var _super = _createSuper(IconWarningLine);

  function IconWarningLine() {
    _classCallCheck(this, IconWarningLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconWarningLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconWarning",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconWarningLine.displayName = "IconWarningLine";
  return IconWarningLine;
}(Component);

IconWarningLine.glyphName = 'warning';
IconWarningLine.variant = 'Line';
IconWarningLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconWarningLine;
export { IconWarningLine };